import { useState, useRef, useEffect } from 'react'

const FONT = "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"

export default function InputBar({ onSend, disabled, agentName, placeholder }) {
  const [value, setValue] = useState('')
  const inputRef = useRef(null)

  function handleSend() {
    const trimmed = value.trim()
    if (!trimmed || disabled) return
    onSend?.(trimmed)
    setValue('')
    inputRef.current?.focus()
  }

  function handleKeyDown(e) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      handleSend()
    }
  }

  // Focus on mount and whenever disabled goes false (after agent responds)
  useEffect(() => { inputRef.current?.focus() }, [])
  useEffect(() => { if (!disabled) inputRef.current?.focus() }, [disabled])

  const canSend = value.trim().length > 0 && !disabled

  const containerStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    background: '#ffffff',
    borderRadius: 16,
    padding: '8px 8px 8px 16px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.12)',
    border: '1px solid rgba(255,255,255,0.6)',
    flex: 1,
  }

  const inputStyle = {
    flex: 1,
    border: 'none',
    outline: 'none',
    background: 'transparent',
    fontFamily: FONT,
    fontSize: 14,
    color: '#1a1a2e',
    lineHeight: 1.4,
  }

  const btnStyle = {
    width: 36,
    height: 36,
    borderRadius: 10,
    border: 'none',
    cursor: canSend ? 'pointer' : 'default',
    background: canSend ? 'rgb(var(--color-primary, 16 185 129))' : '#e2e8f0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'background 0.2s ease',
    flexShrink: 0,
    outline: 'none',
  }

  return (
    <div style={containerStyle} onClick={() => inputRef.current?.focus()}>
      <input
        ref={inputRef}
        style={inputStyle}
        type="text"
        value={value}
        onChange={e => setValue(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={placeholder || `Ask ${agentName || 'Agent'}...`}
        disabled={disabled}
        autoComplete="off"
      />
      <button style={btnStyle} onClick={handleSend} disabled={!canSend}>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path
            d="M2 8h12M8 2l6 6-6 6"
            stroke={canSend ? '#ffffff' : '#94a3b8'}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
    </div>
  )
}
